export enum TestMessageStep {
    PREVIEW = 'preview',
    AUDIENCE = 'audience',
}

export enum TestFormulaSectionType {
    FORM = 'FORM',
    SUCCESS = 'SUCCESS',
    ERROR = 'ERROR',
    NOTIFY_US = 'NOTIFY_US',
    NEED_HELP = 'NEED_HELP',
}

export const initialFilters = {
    dataset_content: {},
    alternates: {},
    cms_placeholders: {},
};
